import { secondDatabase } from "../../../../config/firebase";

const fetchAndReturnMasterfile = async (firmDetailsID) => {
  const path = `${firmDetailsID}/projectMasterFile/materials`;
  console.log('fetchAndReturnMasterfile path : ', path);
  const ref = secondDatabase.ref(path);
  
  try {
    const snapshot = await ref.once("value");
    console.log('fetchAndReturnMasterfile snapshot.exists() : ', snapshot.exists());

    if (snapshot.exists()) {
      return Object.values(snapshot.val());
    } else {
      return [];
    }
  } catch (error) {
    console.error(`Error checking path ${path}:`, error);
    return [];
  }
};

export default fetchAndReturnMasterfile;
